export enum SldsAlertVariant {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}
